export default __webpack_public_path__ + "static/inn-cloud-4e926bd50095886c72256a12c700caed.svg";